<h1 mat-dialog-title class="text-danger text-decoration-underline fw-bold">Confirmation</h1>
<div mat-dialog-content>
    <p>{{ data.message }}</p>
    <p><span class="text-decoration-underline">Note:-</span>&nbsp;This action is irreversible and may have serious consequences. Are you sure you want to proceed?</p>
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="warn" (click)="onConfirm()">Confirm</button>
</div>